<template>
  <div class="variant-selection">
    <PrivateAdLicensePlateLookup
      :event-bus="eventBus"
      :initial-license-plate="initialLicensePlate"
      :product-type-id="productTypeId"
      :license-plate="licensePlate"
      ref="plateLookupComponent"
    ></PrivateAdLicensePlateLookup>

    <div class="variant-selection__separator">
      <span class="variant-selection__separator-text">eller</span>
    </div>

    <VehicleDesignation
      :event-bus="eventBus"
      :initial-designation-lists="initialDesignationLists"
      :product-type-id="productTypeId"
      :visible="manuallySelectionVisible"
      :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
      ref="designationComponent"
    ></VehicleDesignation>

    <PrivateAdVariantList
      :variant-list="variantList"
      :event-bus="eventBus"
      ref="privateAdVariantListComponent"
    ></PrivateAdVariantList>
  </div>
</template>
<script>
import VehicleDesignation from '../VehicleDesignation/VehicleDesignation.vue'
import PrivateAdVariantList from '../PrivateAdVariantList/PrivateAdVariantList.vue'
import PrivateAdLicensePlateLookup from '../PrivateAdLicensePlateLookup/PrivateAdLicensePlateLookup.vue'
import { scrollToView } from '../../Steps/StepsFunctions'

export default {
  components: {
    VehicleDesignation,
    PrivateAdVariantList,
    PrivateAdLicensePlateLookup,
  },
  props: {
    eventBus: { default: null, type: Object },
    productTypeId: { default: null, type: Number },
    initialDesignationLists: { default: null, type: Array },
    initialLicensePlate: { default: '', type: String },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
  },
  data() {
    return {
      variantList: [],
      manuallySelectionVisible: false,
      licensePlate: '',
    }
  },
  methods: {
    setVariantList(setVariantListObj) {
      this.variantList = setVariantListObj.variantList

      if (setVariantListObj.licensePlate) {
        this.licensePlate = setVariantListObj.licensePlate
        this.manuallySelectionVisible = false
      } else {
        this.licensePlate = ''
      }
      this.emitLicensePlate()
    },
    setManuelSelectionVisibility(visible) {
      this.manuallySelectionVisible = visible
    },
    handleSelection() {
      this.licensePlate = ''
      this.variantList = []
    },
    emitLicensePlate() {
      this.eventBus.emit(
        'variant-selection-license-plate-callback',
        this.licensePlate
      )
    },
    clearErrors() {
      this.$refs.privateAdVariantListComponent.setError('')
      this.$refs.designationComponent.setError('')
      this.$refs.plateLookupComponent.setError('')
    },
    isValid() {
      let errorContainer = ''
      let offset = 0
      if (!this.$refs.privateAdVariantListComponent.isValid()) {
        if (this.variantList.length !== 0) {
          this.$refs.privateAdVariantListComponent.setError(
            'Vælg den variant fra listen, der matcher dit køretøj'
          )
          errorContainer = 'privateAdVariantListComponent'
          offset = 10
        } else if (
          this.manuallySelectionVisible &&
          this.variantList.length === 0
        ) {
          this.$refs.designationComponent.setError(
            'Færdiggør manuel udpegning. Du kan også indtaste nummerplade og trykke "indhent oplysninger"'
          )
          errorContainer = 'designationComponent'
          offset = -50
        } else {
          this.$refs.plateLookupComponent.setError(
            'Fremsøg dit køretøj via nummerplade eller gennem manuel udpegning'
          )
          errorContainer = 'plateLookupComponent'
          offset = 25
        }

        setTimeout(() => {
          scrollToView(this.$refs[errorContainer].$el, offset)
        }, 50)

        return false
      }

      return true
    },
  },
  watch: {
    manuallySelectionVisible() {
      this.clearErrors()
    },
  },
  created() {
    if (this.eventBus === null) return
    this.eventBus.on('private-ad-select-variant-list', this.setVariantList)
    this.eventBus.on(
      'private-ad-select-manuel-selection-callback',
      this.setManuelSelectionVisibility
    )
    this.eventBus.on('private-ad-select-selection', this.handleSelection)
  },
}
</script>

<style lang="scss">
@import 'VariantSelection.scss';
</style>
